import { useStore } from "vuex";
import { getModule } from "vuex-module-decorators";

import AppStatusModule from "~/store/AppStatusModule";

/**
 * A composable/hook that provides the appStatusStore
 * @returns the current AppStatusModule store instance
 */
export default function () {
  const store = useStore();

  return getModule(AppStatusModule, store);
}
